import React from 'react';
const IconActionPhoto = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19ZM10.9999 16.51L8.49991 13.5L4.99991 18H18.9999L14.4999 12L10.9999 16.51Z" fill="#666666"/>
</svg>
);
};
export default IconActionPhoto;